import React from 'react'
import { Route, Routes } from "react-router-dom";
import AnnoncesPage from '../../pages/features/annonces/AnnoncesPage';
import NewAnnoncePage from '../../pages/features/annonces/NewAnnoncePage';




export default function AnnonceNav() {
  return (
    <Routes>
      <Route path="/" element={<AnnoncesPage />} />
      <Route path="/new" element={<NewAnnoncePage />} />

    </Routes>
  );
}
